jQuery(document).ready(function($){
  const swiperItem = new Swiper('.blocks-slider', {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
    750: {
        slidesPerView: 'auto',
    },
    }
  })
})